// pipes
import { titleCasePipe } from "shared/pipes";

// components
import { LateRow } from "./late-row";

const BoxesTable = ({ data }) => {
    const columns = ['user', 'email', 'box_from', "late_from", 'action'];

    if (data.length === 0) {
        return (
            <>
                <div className="icon-text">
                    <span className="icon is-strong has-text-danger">
                        <i className="fas fa-ban"></i>
                    </span>
                    <span className="title is-4">No Results</span>
                </div>

                <p className="block">
                    There is no results for this query.
                </p>
            </>
        )
    };

    return (
        <table className="table is-striped is-fullwidth">
            <thead>
                <tr>
                    {columns.map((column) => (
                        <th key={column}>{titleCasePipe.transform(column)}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.map((lateBox, index) => (
                    <LateRow box={lateBox} key={`row-${index}`} count={index + 1} />
                ))}
            </tbody>
        </table>
    )
};

export { BoxesTable };
